import type { AdminMarket } from "@/hooks/useAdminMarket";

/**
 * Every admin module is available in both markets (PT and BR). Isolation is
 * NOT done by hiding modules — it is enforced server-side by the
 * `market_scope_isolation` RESTRICTIVE RLS policies (market_row_allowed) on
 * each operational table, plus per-market `market` columns defaulting to 'pt'.
 * This helper exists as the single place that documents/enforces that rule and
 * as the seam for any future genuinely market-only module.
 */
// IA is Portugal-only (user decision): the assistant relies on PT data/TOConline.
const PT_ONLY_MODULE_KEYS = new Set<string>(["ia"]);

export function isModuleAllowedInMarket(moduleKey: string, market: AdminMarket): boolean {
  if (market === "br" && PT_ONLY_MODULE_KEYS.has(moduleKey)) return false;
  return true;
}

export function filterModulesByMarket<T extends { moduleKey: string }>(mods: T[], market: AdminMarket): T[] {
  return mods.filter((m) => isModuleAllowedInMarket(m.moduleKey, market));
}
